import { useState, useEffect } from "react";
import { styles } from "../style";
import { Link } from "react-router-dom";
import { close, logo, menu } from "../assets";
import { navLink } from "../constant";

const NavBar = () => {
    const [active, setActive] = useState('')
    const [toggle, setToggle] = useState(false)
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            if (scrollTop > 100) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <nav className={`${styles.paddingX} py-5 flex items-center w-full fixed top-0 z-[20] ${scrolled ? "bg-primary" : "bg-transparent font-poppins"
            }`}>
            <div className="mx-auto flex w-full max-w-7xl justify-between">
                <Link onClick={() => {
                    setActive(""); window.scrollTo(0, 0);
                }} className="flex items-center gap-2 font-bold" to="/">
                    <img className="w-9 h-9 object-contain" src={logo} alt="logo" />
                    <p className="text-white cursor-pointer text-[18px]">Damydavo</p>
                </Link>

                <ul className="hidden md:flex space-x-8 items-center font-semibold">
                    {navLink.map((item) => (
                        <li onClick={() => setActive(item.title)} key={item.id} className={`${active === item.title ? 'text-white' : 'text-secondary'} hover:text-white text-[18px] font-medium cursor-pointer`}><a href={`#${item.id}`}>{item.title}</a></li>
                    ))}
                </ul>
            </div>

            <div className="md:hidden sm:flex items-center justify-end">
                <img onClick={() => setToggle(!toggle)} className="w-[30px] h-[30px] object-contain" src={toggle ? close : menu} alt="menu" />

                <div className={`${!toggle ? "hidden" : "flex"} bg-black-gradient p-6 justify-end absolute top-20 right-0 min-w-[160px] mx-4 my-6 z-20 rounded-lg sidebar`}>
                    <ul className="flex-col justify-end space-y-6 items-center font-semibold">
                        {navLink.map(item => {
                            return <li onClick={() => { setToggle(!toggle); setActive(item.title); }} className={`${active === item.title ? "text-white" : "text-secondary"} cursor-pointer hover:text-secondary font-[18px]`} key={item.id}><a href={`#${item.id}`}>{item.title}</a></li>
                        })}
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default NavBar;